import './GuardianOfZone.css';

export default function InquisidorGuardian() {
  return (
    <svg className="guardian-svg guardian-inquisidor" viewBox="0 0 100 150" role="img">
      <title>Inquisidor — El Meca-Paladín, en postura de poder con brazos cruzados</title>
      <rect x="34" y="8" width="9" height="14" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <rect x="57" y="8" width="9" height="14" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <path d="M28 20 L72 20 L68 48 L32 48 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.4" opacity="0.95" />
      <rect x="26" y="30" width="48" height="8" className="g-cutout" />
      <rect x="29" y="32.5" width="18" height="3.5" className="g-fill-core g-scan-tight" />
      <rect x="53" y="32.5" width="18" height="3.5" className="g-fill-core g-scan-tight" />
      <rect x="36" y="41" width="28" height="3" className="g-cutout" />
      <path d="M20 50 L80 50 L86 92 L14 92 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.6" opacity="0.92" />
      <path d="M18 54 L58 68 L54 78 L14 66 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.3" opacity="0.9" />
      <path d="M82 54 L42 68 L46 78 L86 66 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.3" opacity="0.9" />
      <path d="M30 65 L50 75" fill="none" className="g-stroke-a" strokeWidth="6" strokeLinecap="round" opacity="0.9" />
      <path d="M70 65 L50 75" fill="none" className="g-stroke-a" strokeWidth="6" strokeLinecap="round" opacity="0.9" />
      <rect x="10" y="58" width="12" height="11" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <rect x="78" y="58" width="12" height="11" className="g-fill-a g-stroke-bg" strokeWidth="1" />
      <path d="M26 92 L40 92 L36 145 L18 145 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.5" opacity="0.9" />
      <path d="M74 92 L60 92 L64 145 L82 145 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.5" opacity="0.9" />
      <rect x="14" y="140" width="26" height="8" className="g-fill-a g-stroke-bg" strokeWidth="1.2" />
      <rect x="60" y="140" width="26" height="8" className="g-fill-a g-stroke-bg" strokeWidth="1.2" />
    </svg>
  );
}
